export {
  useInsertionEffectAlwaysWithSyncFallback,
  useInsertionEffectWithLayoutFallback
} from "./emotion-use-insertion-effect-with-fallbacks.browser.cjs.js";
